var render = function render(){var _vm=this,_c=_vm._self._c;return (this.FooterData)?_c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-box",domProps:{"innerHTML":_vm._s(this.FooterData.Footer_Text)}})]),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_c('p',[_vm._v("Copyright © 2022 Tainan City Government.")])])
}]

export { render, staticRenderFns }